import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Icon } from '@vectord/components';

export default function RescheduleClassesButton() {
  const { superBatchId } = useParams();

  return (
    <div>
      <Icon
        name="double-refresh"
        className="m-r-xxs"
      />
      <Link
        className="link"
        to={`/classes/reschedule/${superBatchId}`}
      >
        Reschedule Classes
      </Link>
    </div>
  );
}
